import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import MobileActionBar from "./MobileActionBar";

export default function Layout({ children }) {
  return (
    <div className="App">
      <Navbar />
      <main className="pb-[60px] lg:pb-0">{children}</main>
      <Footer />
      <ChatWidget />
      <MobileActionBar />
    </div>
  );
}
